import { Link } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { styled } from "@mui/material/styles";
import useAuth from "hooks/useAuth";
import { IconDashboard, IconLogout } from "@tabler/icons";
import { APPBAR_DESKTOP, APPBAR_MOBILE, DRAWER_WIDTH } from "components/data/constrain";

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: theme.palette.primary[500],
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
  "@media print": {
    display: "none",
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  color: "#fff",
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

export default function Header({ onOpenSidebar }) {
  const { user, logout } = useAuth();

  return (
    <RootStyle>
      <ToolbarStyle>
        <IconButton
          color="inherit"
          onClick={onOpenSidebar}
          sx={{ mr: 1, displayPrint: "none", display: { lg: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        <Typography variant="h6" sx={{ fontSize: 19, flexGrow: 1 }}>
          <Link to="/">NEPTUNE DEVELOPMENT LTD</Link>
        </Typography>
        {user ? (
          <>
            <Button
              startIcon={<IconDashboard stroke={1.5} size={20} />}
              sx={{ p: 0, fontSize: "1rem", fontWeight: "normal" }}
            >
              <Link to="/admin/dashboard">Dashboard</Link>
            </Button>

            <Button
              startIcon={<IconLogout stroke={1.5} size={20} />}
              sx={{ ml: 3, p: 0, fontSize: "1rem", fontWeight: "normal" }}
              onClick={logout}
            >
              logout
            </Button>
          </>
        ) : (
          <Button
            startIcon={<IconLogout stroke={1.5} size={20} />}
            sx={{ p: 0, fontSize: "1rem", fontWeight: "normal" }}
          >
            <Link to="/login">Login</Link>
          </Button>
        )}
      </ToolbarStyle>
    </RootStyle>
  );
}
